// hooks/useOrganisationData.ts
import { useQuery } from '@tanstack/react-query';
import { fetchOrganisationData, FetchOrganisationDataArgs } from './helper';

export const useOrganisationData = (args: FetchOrganisationDataArgs) => {
  return useQuery({
    queryKey: ['organisationData', args.practiseAdminId, args.organisationId],
    queryFn: () => fetchOrganisationData(args),
    enabled: !!args.practiseAdminId && !!args.organisationId // only run if args exist
  });
};
